// extracted by mini-css-extract-plugin
export default {"loginFormForgot":"RoleModal_loginFormForgot__uAPrP","loginFormButton":"RoleModal_loginFormButton__-F+tM"};